import { createTicketHooks } from "@brad-tipper/app-frontend/tickets";

import { api } from "~/api/client";

export const {
  useTickets,
  useTicket,
  useCreateTicket,
  useAddTicketNote,
  useSetTicketStatus,
} = createTicketHooks(api);
